import { render, staticRenderFns } from "./Last_Orders.vue?vue&type=template&id=0d20b878&scoped=true"
import script from "./Last_Orders.vue?vue&type=script&lang=js"
export * from "./Last_Orders.vue?vue&type=script&lang=js"
import style0 from "./Last_Orders.vue?vue&type=style&index=0&id=0d20b878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20b878",
  null
  
)

export default component.exports